import { Description, Dvr, HomeRepairService, LocalOffer, TrendingUp } from "@mui/icons-material";
import IReport from "../interfaces/IReport";
import RoomOverviewFilters from "../pages/Admin/Governance/Reports/RoomOverview/Filters";
import RoomOverviewContent from "../pages/Admin/Governance/Reports/RoomOverview/Content";
import RoomLogFilters from "../pages/Admin/Governance/Reports/RoomLog/Filters";
import RoomLogContent from "../pages/Admin/Governance/Reports/RoomLog/Content";
import GovernanceStatisticalLogFilters from "../pages/Admin/Governance/Reports/StatisticalLog/Filters";
import GovernanceStatisticalLogContent from "../pages/Admin/Governance/Reports/StatisticalLog/Content";
import ServiceOrdersFilters from "../pages/Admin/Service/Reports/ServiceOrders/Filters";
import ServiceOrdersContent from "../pages/Admin/Service/Reports/ServiceOrders/Content";
import ServiceOrderLogFilters from "../pages/Admin/Service/Reports/ServiceOrderLog/Filters";
import ServiceOrderLogContent from "../pages/Admin/Service/Reports/ServiceOrderLog/Content";
import ServiceStatisticalLogFilters from "../pages/Admin/Service/Reports/StatisticalLog/Filters";
import ServiceStatisticalLogContent from "../pages/Admin/Service/Reports/StatisticalLog/Content";
import ServiceOrdersByTagFilters from "../pages/Admin/Service/Reports/ServiceOrdersByTag/Filters";
import ServiceOrdersByTagContent from "../pages/Admin/Service/Reports/ServiceOrdersByTag/Content";


export const GovernanceReports: IReport[] = [
    {
        title: "roomOverview",
        subtitle: '_roomOverviewDescription',
        Icon: Dvr,
        alias: 'Governance.Reports.RoomOverview',
        Filters: RoomOverviewFilters,
        Content: RoomOverviewContent,
    }, {
        title: "roomLog",
        subtitle: '_roomLogDescription',
        Icon: Description,
        alias: 'Governance.Reports.RoomLog',
        Filters: RoomLogFilters,
        Content: RoomLogContent,
    }, {
        title: "statisticalLog",
        subtitle: '_statisticalLogDescription',
        Icon: TrendingUp,
        alias: 'Governance.Reports.StatisticalLog',
        Filters: GovernanceStatisticalLogFilters,
        Content: GovernanceStatisticalLogContent,
    }
];


export const ServiceReports: IReport[] = [
    {
        title: "serviceOrders",
        subtitle: '_serviceOrdersDescription',
        Icon: HomeRepairService,
        alias: 'Service.Reports.ServiceOrders',
        Filters: ServiceOrdersFilters,
        Content: ServiceOrdersContent,
    }, {
        title: "serviceOrderLog",
        subtitle: '_serviceOrderLogDescription',
        Icon: Description,
        alias: 'Service.Reports.ServiceOrderLog',
        Filters: ServiceOrderLogFilters,
        Content: ServiceOrderLogContent,
    }, {
        title: "statisticalLog",
        subtitle: '_statisticalLogDescription',
        Icon: TrendingUp,
        alias: 'Service.Reports.StatisticalLog',
        Filters: ServiceStatisticalLogFilters,
        Content: ServiceStatisticalLogContent,
    }, {
        title: "serviceOrdersByTag",
        subtitle: '_serviceOrdersByTagDescription',
        Icon: LocalOffer,
        alias: 'Service.Reports.ServiceOrdersByTag',
        Filters: ServiceOrdersByTagFilters,
        Content: ServiceOrdersByTagContent,
    }
];


export const ReportsAlias = {
    Governance: {
        RoomOverview: 'Governance.Reports.RoomOverview',
        RoomLog: 'Governance.Reports.RoomLog',
        StatisticalLog: 'Governance.Reports.StatisticalLog'
    },
    Service: {
        ServiceOrders: 'Service.Reports.ServiceOrders',
        ServiceOrderLog: 'Service.Reports.ServiceOrderLog',
        StatisticalLog: 'Service.Reports.StatisticalLog',
        ServiceOrdersByTag: 'Service.Reports.ServiceOrdersByTag'
    }
};